'use client';

import { FC, useContext, useState } from 'react';
import { WithSMSFlowProps } from './WithSMSFlow.types';
import {
  Flex,
  Heading,
  Text,
  Button,
  Separator,
  ButtonGroup,
} from '@/_components';
import { UserContext } from '@/_contexts/UserProvider';
import { setSignInMethod } from '@/_api/users';
import { ToastContext } from '@/_contexts/ToastProvider';
import { formatPhoneNumber } from '@/_utils/phoneNumbers';

export const WithSMSFlow: FC<WithSMSFlowProps> = ({ onUpdate }) => {
  const { user, token } = useContext(UserContext);
  const { addToast } = useContext(ToastContext);

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const onSubmit = async () => {
    let isUpdated: boolean = false;
    setIsLoading(true);

    try {
      await setSignInMethod({
        signInMethod: 'sms',
        phoneNumber: user?.phone_number!,
        token,
      });

      isUpdated = true;
      addToast('success', 'Sign-in preference updated successfully');
    } catch (error) {
      addToast('error', null, { error });
    } finally {
      setIsLoading(false);
      onUpdate(isUpdated, 'sms');
    }
  };

  const onCancel = () => onUpdate(false);

  const formattedPhoneNumber = formatPhoneNumber(user?.phone_number);

  return (
    <Flex isColumn={true} gap={8}>
      <Flex isColumn={true} gap={2}>
        <Heading level={3}>Update sign-in method</Heading>
        <Text type="small">
          We&apos;ll send you a code via text the next time you log in: <br />
          <b>{formattedPhoneNumber}</b>
        </Text>
      </Flex>
      <Separator />
      <ButtonGroup align="right">
        <Button
          value="Cancel"
          intent="secondary"
          onClick={onCancel}
          isDisabled={isLoading}
        />
        <Button
          value="Update"
          intent="primary"
          onClick={onSubmit}
          isLoading={isLoading}
          isDisabled={isLoading}
        />
      </ButtonGroup>
    </Flex>
  );
};
